import { PUBLISH_CONTENT_TYPES } from 'helpers/publishContentTypes';
import {
  runBannerPublishJob,
  runTemplatePublishJob,
  runPagesPublishJob,
  runCategoriesPublishJob,
  runWidgetsPublishJob,
  runSeoPublishJob,
  runInformationPolicyPublishJob,
  runAdminSettingsPublishJob,
  runConfigSettingsPublishJob,
  runGalleryPublishJob,
  runOfficialContactPublishJob,
  runAdministrationPublishJob,
  runParishPriestPublishJob,
  runLeadershipHistoryPublishJob,
  runHousePublishJob,
  runHistoryPublishJob,
  runHierarchyPublishJob,
  runChurchPublishJob,
  runOrganizationPublishJob,
  runMembersPublishJob,
  runChapelPublishJob,
  runNewsPublishJob,
  runFestivalsPublishJob,
  runAdvertisementPublishJob,
  runOccasionPublishJob,
  runLiveStreamingPublishJob,
  runIncomePdfLinkPublishJob,
  runEventsPublishJob,
  runQuotesPublishJob,
  runPositionPublishJob,
} from 'helpers/formPublishJobs';

export const runPublishJob = ({ job, files, accessToken, onProgress, signal }) => {
  switch (job.contentType) {
    case PUBLISH_CONTENT_TYPES.BANNER:
      return runBannerPublishJob({ job, files, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.TEMPLATE:
      return runTemplatePublishJob({ job, files, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.PAGES:
      return runPagesPublishJob({ job, files, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.CATEGORIES:
      return runCategoriesPublishJob({ job, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.WIDGETS:
      return runWidgetsPublishJob({ job, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.SEO:
      return runSeoPublishJob({ job, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.INFORMATION_POLICY:
      return runInformationPolicyPublishJob({ job, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.ADMIN_SETTINGS:
      return runAdminSettingsPublishJob({ job, files, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.CONFIG_SETTINGS:
      return runConfigSettingsPublishJob({ job, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.GALLERY:
      return runGalleryPublishJob({ job, files,accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.OFFICIAL_CONTACT:
      return runOfficialContactPublishJob({ job, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.ADMINISTRATION:
      return runAdministrationPublishJob({ job, files, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.PARISH_PRIEST:
      return runParishPriestPublishJob({ job, files, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.LEADERSHIP_HISTORY:
      return runLeadershipHistoryPublishJob({ job, files, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.HOUSE:
      return runHousePublishJob({ job, files, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.HISTORY:
      return runHistoryPublishJob({ job, files, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.HIERARCHY:
      return runHierarchyPublishJob({ job, files, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.CHURCH:
      return runChurchPublishJob({ job, files, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.ORGANIZATION:
      return runOrganizationPublishJob({ job, files, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.MEMBERS:
      return runMembersPublishJob({ job, files, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.CHAPEL:
      return runChapelPublishJob({ job, files, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.NEWS:
      return runNewsPublishJob({ job, files, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.FESTIVALS:
      return runFestivalsPublishJob({ job, files, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.ADVERTISEMENT:
      return runAdvertisementPublishJob({ job, files, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.OCCASION:
      return runOccasionPublishJob({ job, files, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.LIVE_STREAMING:
      return runLiveStreamingPublishJob({ job, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.INCOME_PDF_LINK:
      return runIncomePdfLinkPublishJob({ job, files, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.EVENTS:
      return runEventsPublishJob({ job, files, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.QUOTES:
      return runQuotesPublishJob({ job, files, accessToken, onProgress, signal });
    case PUBLISH_CONTENT_TYPES.POSITION:
      return runPositionPublishJob({ job, accessToken, onProgress, signal });
    default:
      throw new Error('Unsupported publish job type.');
  }
};
